import { createFileRoute, Outlet } from "@tanstack/react-router"

import { findOrderedStepByNameAndSessionId } from "@/services/dexie"

export const Route = createFileRoute("/$sessionId/_session/claim")({
  loader: async ({ params }) => {
    const step = await findOrderedStepByNameAndSessionId("Claim", params.sessionId)

    return {
      enableUpload: step?.enableUpload === true,
      viewsCheck: step?.viewsCheck === true,
      qualityCheck: step?.qualityCheck === true,
    }
  },
  component: () => <Outlet />,
})
